var _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-20"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11,314.57H153c-34.58,0-57-9.07-63.28-25.5a.91.91,0,0,1,.52-1.16.89.89,0,0,1,1.16.52c5.94,15.68,27.82,24.32,61.6,24.35h.13c34,0,76-8.79,118.09-24.75s79.41-37.23,104.91-59.84c25.28-22.41,35.92-43.38,30-59.06a.9.9,0,1,1,1.68-.63c6.23,16.42-4.59,38.1-30.47,61-25.66,22.74-63.11,44.11-105.47,60.17S187.37,314.57,153.11,314.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.59,375.48c-13.21,0-29.84-6.16-48.69-18.26-28.85-18.52-59.59-48.77-86.54-85.18s-46.9-74.63-56.18-107.64c-9.36-33.29-6.75-57.38,7.37-67.83A.9.9,0,1,1,148.62,98c-28.08,20.78-6,98.37,49.19,173s123,118.35,151,97.57a.91.91,0,0,1,1.26.19.9.9,0,0,1-.19,1.25C345,373.66,338.78,375.48,331.59,375.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.78,244.21c0-4.37.16-8.69.54-13a131.71,131.71,0,0,1,130.24-119.7H251a131.3,131.3,0,0,1,46.93,9.16h0a131.85,131.85,0,0,1,82.53,108.15q.72,6.65.78,13.46a131.72,131.72,0,1,1-263.43,1.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,339.22c-2.47.24-3.58,3.28-4.09,5.76-.74,3.72-1.5,7.44-2.25,11.16,4.53,2.13,4.16,7.65,2.05,11.4a131.76,131.76,0,0,1-88-123.33c0-4.37.16-8.69.54-13l.34-.19c3.59-1.69,6.42,1.38,9.13,3.11.61.39,8.5,4.22,8.61,3.16a34.78,34.78,0,0,0,.54,10.33,1,1,0,0,0,.35.68c.51.36,1.09-.35,1.28-.95.48-1.52.68-3.12,1.25-4.6a5.41,5.41,0,0,1,3.13-3.4c1.53-.48,3.19.09,4.78-.13a6.55,6.55,0,0,0,4.52-3.4,21.42,21.42,0,0,0,1.86-5.32c1.86,4.13,6.58,1.58,9.35,4.92.89,1.08,2,2.62,3.26,2.1s1.37-2.59,2.69-2.76c.92-.11,1.59.9,1.73,1.82a9.91,9.91,0,0,0,.37,2.74,2.42,2.42,0,0,0,3.32,1c1-.61,1.39-1.84,2-2.83s2-1.82,2.92-1.13a2,2,0,0,1,.51.64c.92,1.76-.12,3.9-1.35,5.46s-2.73,3.12-2.86,5.1a1.65,1.65,0,0,0,2.28-.48,2.63,2.63,0,0,1,.48-.77c.5-.43,1.25,0,1.81.33a11.84,11.84,0,0,0,9,1.59q.34-6,.68-12c.91,0,1.45-.09,1.8-1,3,2.93,5.77,6.09,9.09,8.73a2.46,2.46,0,0,1,.95,1.15,7.63,7.63,0,0,1,0,1.58c.11,1.76,2.46,2.22,4.22,2.17.5.28.21,1.12-.3,1.4s-1.14.31-1.6.67a2.24,2.24,0,0,0-.45,2.42,5.79,5.79,0,0,0,7.26,3.61,1.69,1.69,0,0,0,.88-.59c.44-.66,0-1.53-.06-2.31-.32-3.11,3-2.39,4.59-1.53,2.09,1.16,3.27,4.26,3.66,6.47.46,2.58,2.41,19.74,8.14,17.37a2.58,2.58,0,0,0,1.2-1.22c.82-1.56.77-3.43,1.37-5.09s2.49-3.17,4-2.31c.62.35,1,1,1.61,1.38,1.64,1.09,4-.22,5.78.6a16.82,16.82,0,0,1,2.14,1.66c.75.51,1.92.67,2.45-.06s-.1-2.07.38-3a1.59,1.59,0,0,1,2.62.18,2.75,2.75,0,0,1-.44,3,3.47,3.47,0,0,0-.91,1.38c-.21,1,.72,1.79,1.54,2.36l3.92,2.71a2.35,2.35,0,0,1-1.84,1.78c-.88.25-1.81.24-2.68.52-4.18,1.4-4.16,7.6-9.65,6.38a2.64,2.64,0,0,0-3.06-2.92c-2,.5-3.31,3.36-5.3,2.79-.69-.19-1.22-.79-1.92-1-1.94-.46-2.88,2.51-3.43,3.78-1.8,4.2,1,4.71.89,8.45,0,1.72-1.32,3.17-1.63,4.85s.25,3.16,0,4.73c-.58,4.3-6.27,1.69-8.8,1.19,1.38,2.44-.66,5.41-2.89,7.1-3.41,2.59-2.83,2.37-3.25,6.12a2.74,2.74,0,0,1-1.62,2.32c-1.64.58-3.23-1-4.95-1.2-.83-.08-1.67.18-2.49,0-2.15-.36-2.9-3-4.31-4.68a6,6,0,0,0-5.1-2.06,12.45,12.45,0,0,0,0,3.34l3.62,2.23a8.21,8.21,0,0,1,2.83,2.42,6.8,6.8,0,0,0,1.14,1.77c1.06.9,2.66.35,4.05.26,3.38-.22,8.88,1.89,12.13,3,3.47,1.14,4.68,3.59,7.88,4.69a1,1,0,0,1,.36,1.51,2.25,2.25,0,0,1-1.53.81,6.1,6.1,0,0,1-4-.66c1.59.87-3.06,4.72-3.9,4.9-1.38.32-3.24-.72-4.64-.8-3.48-.17-5.5.52-3.21,4.3.87,1.45,1.89,3.3.93,4.69a2.18,2.18,0,0,0-2.55,1,4.68,4.68,0,0,0-.44,2.91,2.93,2.93,0,0,0,.73,1.83,5,5,0,0,1,.8.72c.65,1-.68,2-1.77,2.46",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.29,188.34c-1.08-.81-2.62-.16-3.75.59s-2.45,1.62-3.72,1.16l-.08-4.71a1.11,1.11,0,0,0-.23-.82,1.15,1.15,0,0,0-.85-.2l-3,.14c-.85.93,1.5,2.06,1.17,3.27-.15.53-.75.76-1.24,1-4.16,2.24-1.52,6.88.36,9.4,2.19,2.92,2,6.91,1.81,10.56-.09,1.3-.24,2.75-1.24,3.6s-2.41.78-3.65,1.14c-2.16.63-3.68,2.54-5.69,3.53-7,3.46-11.69-4.07-9.39-10,1.18-3.08,1.69-2.5,1-5.78-.28-1.38.17-3-1.25-3.93a2.52,2.52,0,0,0-3.82,1.91c-.12,1.81-.53,3.53.21,5.23-2.08-.78-4.56-.28-6.84-.29a3,3,0,0,1-4.22,2.88c.07-1-.21-2.44-1.24-2.43a1.74,1.74,0,0,0-.84.3c-1.08.63-2,1.48-3.17,2-1.75.81-6.78.42-7.57,2.78-.13.42-.13.87-.3,1.28a2,2,0,0,1-2.33,1,2.64,2.64,0,0,1-1.7-2.05c-.12-.61-.06-1.25-.21-1.85-.85-3.18-4.12-.69-5.59-1.55-.7-.41-3.59-5.84-3.65-6.5-1.39,1.73-3.47,3.19-5.78,3.08-2.54-.12-3.62-2.13-4.19-4.59s-.63-5.7-1.2-7.58c-.3-1-.56-2.24.15-3,.9-1,2.8-.6,3.45-1.75A3.63,3.63,0,0,0,247,185a4.65,4.65,0,0,1,5.52-3.56c.77-.51.79-1.62.83-2.55s.44-2.08,1.37-2.14,1.55,1.32,1.53,2.39a11.33,11.33,0,0,1-.5,3.22,3.88,3.88,0,0,0-.28,2.38,3.11,3.11,0,0,0,1.22,1.35,7.14,7.14,0,0,0,4.06,1.64,3,3,0,0,0,3.1-2.58,6.76,6.76,0,0,1,0-1.19c.24-1,1.51-1.33,2.53-1.2a9.23,9.23,0,0,0,3,.36c1-.2,1.84-1.51,1.13-2.25,1.34-.47,3.27-.7,3.8.62a3.87,3.87,0,0,1,.13,1.36c.05,2.83,3.57,6.91,6,4,1.58-1.95-1.14-5.49,1.69-7.09,1.36-.76,3.19-.09,4.53-.88.42-.49-.3-1.16-.93-1.33A6,6,0,0,0,280,179c-.8-1.65.44-4.06-1-5.25s-4,.21-5.07-1.28a2.79,2.79,0,0,1-.38-1.48c-.19-2.56.6-7.24-3-7.67a5.1,5.1,0,0,1-1.3-.18c-1.25-.49-1.24-2.23-1-3.54,1.36-.59,2.81.42,4.12,1.11s3.37.8,3.82-.6c.31-1-.48-2.27.19-3.09.31-.38.86-.52,1.12-.94.63-1-.91-2-1.18-3.16-.38-1.58,1.74-2.61,3.37-2.48s3.45.66,4.77-.3c.41-.31.72-.74,1.11-1.09,1.19-1,2.93-1.15,4.52-1.19,2.54-.07-3.24-10.52-3.3-11.16-.44-4.85,4.54-7.43,7.39-10.51a29.58,29.58,0,0,0,3.66-5.48c42.83,17,74.51,56.28,81.69,101.81a42.1,42.1,0,0,1,.72,6.19c-3-.85-7.68-3.1-10.73-1.27-3.88,2.32-1.08,8.07-5.54,9.77-1.11,0-.79-1.83-1.43-2.74a3.8,3.8,0,0,0-1.56-.94c-.55-.28-1.08-.87-.86-1.45-1-.76-2.3.21-3.19,1.05a8.08,8.08,0,0,1-3.68,2.2c-2.95.62-5.67-1.5-8.33-2.92a39.06,39.06,0,0,0-7-2.67c1.15.07,1.73-1.52,1.29-2.58a12,12,0,0,0-2.18-2.66c-1.25-1.52-.29-3.28-1.34-4.89-1.29-2-3.77-3.41-4-5.78-.27-2.87,2.91-4.7,5.59-5.77-1.42-3.24-5.26-5.47-5.25-9a9.16,9.16,0,0,1,1.2-3.86c1.21-2.5,2.42-5,3.63-7.5a4.8,4.8,0,0,0,.71-3.3c-.35-1.31-1.69-2.06-2.89-2.67l-3.93-2a3,3,0,0,0-1.73-.44,2.55,2.55,0,0,0-1.5,1.13,14,14,0,0,0-2.8,9.87,56.83,56.83,0,0,1-13.55-3.77c.48,2.68-.63,5.65.2,8.16",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.39,210.32a5.24,5.24,0,0,0-2.33,3.81,22.7,22.7,0,0,0,.32,2.83,2.57,2.57,0,0,1-1,2.48c-1.07.59-2.35-.14-3.34-.84a4,4,0,0,1-1.86-2.2c-.14-.7.11-1.43,0-2.15-.12-1.42-1.38-2.42-2.38-3.43s-1.86-2.61-1.07-3.8c.52-.78,1.58-1.05,2.14-1.81,1.36-1.84-1.1-4.41,0-6.08,1.34-2,4.66-1,6.5,0s3.21,2.9,4.53,4.49C221.68,208.16,220.37,207.47,216.39,210.32Z",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,140.71c22-19.11,52.79-28.94,81.66-29.15H251c3.81,4.29,5.83,12.43-1.72,14,0,.82.47,1,.89,1.68.65,1-.44,2.34-1.57,2.8-3.7,1.54-8.2,1.45-7.61,6.47.7,6,3.53,2.17,6.64,4.34a7.07,7.07,0,0,1,1.07,1.24c1.32,1.52,3.64,1.51,5.65,1.37a2.3,2.3,0,0,1,1.52-3,3.75,3.75,0,0,0,1.39-.35c.84-.61.21-2-.75-2.44s-2.06-.23-3.06-.52-1.9-1.47-1.3-2.31a1.76,1.76,0,0,1,1.12-.61,5.64,5.64,0,0,1,5,1.39,2.27,2.27,0,0,1,4.39.43c.21,1.46-.79,3.45.51,4.14a3.27,3.27,0,0,0-3.25,1c-3.06,3.6-1.24,12.36-9.29,10.89a32.15,32.15,0,0,0-3.84-.85c-1.32-.07-2.82.54-3.17,1.81-1.69-2.46-6-1.94-7.47-4.54a3.17,3.17,0,0,1,.7-3.83,1.43,1.43,0,0,0,.47-.51c.17-.44-.22-.89-.29-1.36-.11-.82.78-1.45.89-2.27.15-1.14-1.18-1.87-2.29-2.16s-2.48-.7-2.7-1.83c-.08-.38,0-.79-.08-1.17a2,2,0,0,0-1.73-1.4,5.85,5.85,0,0,0-2.33.35c-.52.44-.29,1.32.18,1.81a14,14,0,0,1,1.48,1.39c.21.32-.83,7.14-.32,7-2.44.85-7.65,1-6.6,4.62.37,1.29,1.12,2.63.64,3.88,1.72-.48,3.44-1,5.17-1.39.42.56-.27,1.31-1,1.48s-1.47.15-1.93.67a2.28,2.28,0,0,0-.39,1.38l-.27,4.76c-.09,1.73-.32,3.7-1.75,4.67-1.62,1.1-3.91.22-5.28-1.19a1.28,1.28,0,0,0-2.24-.13,7.09,7.09,0,0,1-6.19,1.88,4.64,4.64,0,0,1-3.62-4.93c.14-.85.51-1.89-.15-2.45-.39-.33-1-.37-1.22-.84s.54-1,1.05-1.41a2.57,2.57,0,0,0,.75-3.1c-.26-.53-5-2.48-5.76-2.12-1.7.82-1.4,5.37-1.61,7.12a2.55,2.55,0,0,1-.75,1.84c-.86.63-2.09,0-2.75-.86s-1.15-1.89-2.11-2.35a4.47,4.47,0,0,0-1.81-.32c-1.26,0-2.67,0-3.55.88-.41.42-.66,1-1.07,1.39a3.63,3.63,0,0,1-3.77.46c-1.26-.45-2.4-1.23-3.69-1.58-2.75-.73-5.9.57-8.43-.74-1.23-.63-2.11-2.38-1.14-3.35s2.65-.7,2.88-1.87-2.53-2.73-3-3.71c-.38-.78.46-2.22-.43-3.66C169.43,142.33,167.68,142,166.9,140.71Z",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,329.32c1.56-1.05,3.32-1.65,3.86-3.81.74-2.93-.84-4.18-3.75-3.09a1.21,1.21,0,0,1-.81.11c-.84-.27-.24-1.51.31-2.2a5.93,5.93,0,0,0,.7-5.69c-.16-.44,8.06-.63,9-.14,3.17,1.74,1.1,8.49,4.78,7.35.24-2.57.11-5.23.12-7.82l3.75-.14c-.93,0-.38-4.76-.06-5.28,1.23-2,5-1.17,4.69-5-.42-4.86-9.84-5.85-8.71-.27a24.51,24.51,0,0,1-9.29,1.25c-.07,1-.13,2-.19,3a2.69,2.69,0,0,1-2.42.19,7.43,7.43,0,0,1,.54-8.2c-1.08-1.65.23-3.77,1.49-5.29-3.44-2.52-2.45-8.92,1.59-10.28s8.71,3.14,7.49,7.23a9.51,9.51,0,0,1,5.33,2.44,12.48,12.48,0,0,1,9.12-11.25c2.52-.65,5.51-.61,7.23-2.57.77-.86,1.15-2,1.86-2.92,1.61-2,4.49-2.46,7.09-2.61q2.61-.14,5.22-.09a131.75,131.75,0,0,1-49.17,74.57,5.17,5.17,0,0,1-2.66-.39c-1.48-.8-1.94-2.66-2.24-4.31-1.19-6.43-.52-10.43,4.71-14.42A4.84,4.84,0,0,1,328.65,329.32Z",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,339.22c-2.47.24-3.58,3.28-4.09,5.76-.74,3.72-1.5,7.44-2.25,11.16,4.53,2.13,4.16,7.65,2.05,11.4a131.76,131.76,0,0,1-88-123.33c0-4.37.16-8.69.54-13l.34-.19c3.59-1.69,6.42,1.38,9.13,3.11.61.39,8.5,4.22,8.61,3.16a34.78,34.78,0,0,0,.54,10.33,1,1,0,0,0,.35.68c.51.36,1.09-.35,1.28-.95.48-1.52.68-3.12,1.25-4.6a5.41,5.41,0,0,1,3.13-3.4c1.53-.48,3.19.09,4.78-.13a6.55,6.55,0,0,0,4.52-3.4,21.42,21.42,0,0,0,1.86-5.32c1.86,4.13,6.58,1.58,9.35,4.92.89,1.08,2,2.62,3.26,2.1s1.37-2.59,2.69-2.76c.92-.11,1.59.9,1.73,1.82a9.91,9.91,0,0,0,.37,2.74,2.42,2.42,0,0,0,3.32,1c1-.61,1.39-1.84,2-2.83s2-1.82,2.92-1.13a2,2,0,0,1,.51.64c.92,1.76-.12,3.9-1.35,5.46s-2.73,3.12-2.86,5.1a1.65,1.65,0,0,0,2.28-.48,2.63,2.63,0,0,1,.48-.77c.5-.43,1.25,0,1.81.33a11.84,11.84,0,0,0,9,1.59q.34-6,.68-12c.91,0,1.45-.09,1.8-1,3,2.93,5.77,6.09,9.09,8.73a2.46,2.46,0,0,1,.95,1.15,7.63,7.63,0,0,1,0,1.58c.11,1.76,2.46,2.22,4.22,2.17.5.28.21,1.12-.3,1.4s-1.14.31-1.6.67a2.24,2.24,0,0,0-.45,2.42,5.79,5.79,0,0,0,7.26,3.61,1.69,1.69,0,0,0,.88-.59c.44-.66,0-1.53-.06-2.31-.32-3.11,3-2.39,4.59-1.53,2.09,1.16,3.27,4.26,3.66,6.47.46,2.58,2.41,19.74,8.14,17.37a2.58,2.58,0,0,0,1.2-1.22c.82-1.56.77-3.43,1.37-5.09s2.49-3.17,4-2.31c.62.35,1,1,1.61,1.38,1.64,1.09,4-.22,5.78.6a16.82,16.82,0,0,1,2.14,1.66c.75.51,1.92.67,2.45-.06s-.1-2.07.38-3a1.59,1.59,0,0,1,2.62.18,2.75,2.75,0,0,1-.44,3,3.47,3.47,0,0,0-.91,1.38c-.21,1,.72,1.79,1.54,2.36l3.92,2.71a2.35,2.35,0,0,1-1.84,1.78c-.88.25-1.81.24-2.68.52-4.18,1.4-4.16,7.6-9.65,6.38a2.64,2.64,0,0,0-3.06-2.92c-2,.5-3.31,3.36-5.3,2.79-.69-.19-1.22-.79-1.92-1-1.94-.46-2.88,2.51-3.43,3.78-1.8,4.2,1,4.71.89,8.45,0,1.72-1.32,3.17-1.63,4.85s.25,3.16,0,4.73c-.58,4.3-6.27,1.69-8.8,1.19,1.38,2.44-.66,5.41-2.89,7.1-3.41,2.59-2.83,2.37-3.25,6.12a2.74,2.74,0,0,1-1.62,2.32c-1.64.58-3.23-1-4.95-1.2-.83-.08-1.67.18-2.49,0-2.15-.36-2.9-3-4.31-4.68a6,6,0,0,0-5.1-2.06,12.45,12.45,0,0,0,0,3.34l3.62,2.23a8.21,8.21,0,0,1,2.83,2.42,6.8,6.8,0,0,0,1.14,1.77c1.06.9,2.66.35,4.05.26,3.38-.22,8.88,1.89,12.13,3,3.47,1.14,4.68,3.59,7.88,4.69a1,1,0,0,1,.36,1.51,2.25,2.25,0,0,1-1.53.81,6.1,6.1,0,0,1-4-.66c1.59.87-3.06,4.72-3.9,4.9-1.38.32-3.24-.72-4.64-.8-3.48-.17-5.5.52-3.21,4.3.87,1.45,1.89,3.3.93,4.69a2.18,2.18,0,0,0-2.55,1,4.68,4.68,0,0,0-.44,2.91,2.93,2.93,0,0,0,.73,1.83,5,5,0,0,1,.8.72c.65,1-.68,2-1.77,2.46",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.29,188.34c-1.08-.81-2.62-.16-3.75.59s-2.45,1.62-3.72,1.16l-.08-4.71a1.11,1.11,0,0,0-.23-.82,1.15,1.15,0,0,0-.85-.2l-3,.14c-.85.93,1.5,2.06,1.17,3.27-.15.53-.75.76-1.24,1-4.16,2.24-1.52,6.88.36,9.4,2.19,2.92,2,6.91,1.81,10.56-.09,1.3-.24,2.75-1.24,3.6s-2.41.78-3.65,1.14c-2.16.63-3.68,2.54-5.69,3.53-7,3.46-11.69-4.07-9.39-10,1.18-3.08,1.69-2.5,1-5.78-.28-1.38.17-3-1.25-3.93a2.52,2.52,0,0,0-3.82,1.91c-.12,1.81-.53,3.53.21,5.23-2.08-.78-4.56-.28-6.84-.29a3,3,0,0,1-4.22,2.88c.07-1-.21-2.44-1.24-2.43a1.74,1.74,0,0,0-.84.3c-1.08.63-2,1.48-3.17,2-1.75.81-6.78.42-7.57,2.78-.13.42-.13.87-.3,1.28a2,2,0,0,1-2.33,1,2.64,2.64,0,0,1-1.7-2.05c-.12-.61-.06-1.25-.21-1.85-.85-3.18-4.12-.69-5.59-1.55-.7-.41-3.59-5.84-3.65-6.5-1.39,1.73-3.47,3.19-5.78,3.08-2.54-.12-3.62-2.13-4.19-4.59s-.63-5.7-1.2-7.58c-.3-1-.56-2.24.15-3,.9-1,2.8-.6,3.45-1.75A3.63,3.63,0,0,0,247,185a4.65,4.65,0,0,1,5.52-3.56c.77-.51.79-1.62.83-2.55s.44-2.08,1.37-2.14,1.55,1.32,1.53,2.39a11.33,11.33,0,0,1-.5,3.22,3.88,3.88,0,0,0-.28,2.38,3.11,3.11,0,0,0,1.22,1.35,7.14,7.14,0,0,0,4.06,1.64,3,3,0,0,0,3.1-2.58,6.76,6.76,0,0,1,0-1.19c.24-1,1.51-1.33,2.53-1.2a9.23,9.23,0,0,0,3,.36c1-.2,1.84-1.51,1.13-2.25,1.34-.47,3.27-.7,3.8.62a3.87,3.87,0,0,1,.13,1.36c.05,2.83,3.57,6.91,6,4,1.58-1.95-1.14-5.49,1.69-7.09,1.36-.76,3.19-.09,4.53-.88.42-.49-.3-1.16-.93-1.33A6,6,0,0,0,280,179c-.8-1.65.44-4.06-1-5.25s-4,.21-5.07-1.28a2.79,2.79,0,0,1-.38-1.48c-.19-2.56.6-7.24-3-7.67a5.1,5.1,0,0,1-1.3-.18c-1.25-.49-1.24-2.23-1-3.54,1.36-.59,2.81.42,4.12,1.11s3.37.8,3.82-.6c.31-1-.48-2.27.19-3.09.31-.38.86-.52,1.12-.94.63-1-.91-2-1.18-3.16-.38-1.58,1.74-2.61,3.37-2.48s3.45.66,4.77-.3c.41-.31.72-.74,1.11-1.09,1.19-1,2.93-1.15,4.52-1.19,2.54-.07-3.24-10.52-3.3-11.16-.44-4.85,4.54-7.43,7.39-10.51a29.58,29.58,0,0,0,3.66-5.48c42.83,17,74.51,56.28,81.69,101.81a42.1,42.1,0,0,1,.72,6.19c-3-.85-7.68-3.1-10.73-1.27-3.88,2.32-1.08,8.07-5.54,9.77-1.11,0-.79-1.83-1.43-2.74a3.8,3.8,0,0,0-1.56-.94c-.55-.28-1.08-.87-.86-1.45-1-.76-2.3.21-3.19,1.05a8.08,8.08,0,0,1-3.68,2.2c-2.95.62-5.67-1.5-8.33-2.92a39.06,39.06,0,0,0-7-2.67c1.15.07,1.73-1.52,1.29-2.58a12,12,0,0,0-2.18-2.66c-1.25-1.52-.29-3.28-1.34-4.89-1.29-2-3.77-3.41-4-5.78-.27-2.87,2.91-4.7,5.59-5.77-1.42-3.24-5.26-5.47-5.25-9a9.16,9.16,0,0,1,1.2-3.86c1.21-2.5,2.42-5,3.63-7.5a4.8,4.8,0,0,0,.71-3.3c-.35-1.31-1.69-2.06-2.89-2.67l-3.93-2a3,3,0,0,0-1.73-.44,2.55,2.55,0,0,0-1.5,1.13,14,14,0,0,0-2.8,9.87,56.83,56.83,0,0,1-13.55-3.77c.48,2.68-.63,5.65.2,8.16",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.39,210.32a5.24,5.24,0,0,0-2.33,3.81,22.7,22.7,0,0,0,.32,2.83,2.57,2.57,0,0,1-1,2.48c-1.07.59-2.35-.14-3.34-.84a4,4,0,0,1-1.86-2.2c-.14-.7.11-1.43,0-2.15-.12-1.42-1.38-2.42-2.38-3.43s-1.86-2.61-1.07-3.8c.52-.78,1.58-1.05,2.14-1.81,1.36-1.84-1.1-4.41,0-6.08,1.34-2,4.66-1,6.5,0s3.21,2.9,4.53,4.49C221.68,208.16,220.37,207.47,216.39,210.32Z",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,140.71c22-19.11,52.79-28.94,81.66-29.15H251c3.81,4.29,5.83,12.43-1.72,14,0,.82.47,1,.89,1.68.65,1-.44,2.34-1.57,2.8-3.7,1.54-8.2,1.45-7.61,6.47.7,6,3.53,2.17,6.64,4.34a7.07,7.07,0,0,1,1.07,1.24c1.32,1.52,3.64,1.51,5.65,1.37a2.3,2.3,0,0,1,1.52-3,3.75,3.75,0,0,0,1.39-.35c.84-.61.21-2-.75-2.44s-2.06-.23-3.06-.52-1.9-1.47-1.3-2.31a1.76,1.76,0,0,1,1.12-.61,5.64,5.64,0,0,1,5,1.39,2.27,2.27,0,0,1,4.39.43c.21,1.46-.79,3.45.51,4.14a3.27,3.27,0,0,0-3.25,1c-3.06,3.6-1.24,12.36-9.29,10.89a32.15,32.15,0,0,0-3.84-.85c-1.32-.07-2.82.54-3.17,1.81-1.69-2.46-6-1.94-7.47-4.54a3.17,3.17,0,0,1,.7-3.83,1.43,1.43,0,0,0,.47-.51c.17-.44-.22-.89-.29-1.36-.11-.82.78-1.45.89-2.27.15-1.14-1.18-1.87-2.29-2.16s-2.48-.7-2.7-1.83c-.08-.38,0-.79-.08-1.17a2,2,0,0,0-1.73-1.4,5.85,5.85,0,0,0-2.33.35c-.52.44-.29,1.32.18,1.81a14,14,0,0,1,1.48,1.39c.21.32-.83,7.14-.32,7-2.44.85-7.65,1-6.6,4.62.37,1.29,1.12,2.63.64,3.88,1.72-.48,3.44-1,5.17-1.39.42.56-.27,1.31-1,1.48s-1.47.15-1.93.67a2.28,2.28,0,0,0-.39,1.38l-.27,4.76c-.09,1.73-.32,3.7-1.75,4.67-1.62,1.1-3.91.22-5.28-1.19a1.28,1.28,0,0,0-2.24-.13,7.09,7.09,0,0,1-6.19,1.88,4.64,4.64,0,0,1-3.62-4.93c.14-.85.51-1.89-.15-2.45-.39-.33-1-.37-1.22-.84s.54-1,1.05-1.41a2.57,2.57,0,0,0,.75-3.1c-.26-.53-5-2.48-5.76-2.12-1.7.82-1.4,5.37-1.61,7.12a2.55,2.55,0,0,1-.75,1.84c-.86.63-2.09,0-2.75-.86s-1.15-1.89-2.11-2.35a4.47,4.47,0,0,0-1.81-.32c-1.26,0-2.67,0-3.55.88-.41.42-.66,1-1.07,1.39a3.63,3.63,0,0,1-3.77.46c-1.26-.45-2.4-1.23-3.69-1.58-2.75-.73-5.9.57-8.43-.74-1.23-.63-2.11-2.38-1.14-3.35s2.65-.7,2.88-1.87-2.53-2.73-3-3.71c-.38-.78.46-2.22-.43-3.66C169.43,142.33,167.68,142,166.9,140.71Z",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,329.32c1.56-1.05,3.32-1.65,3.86-3.81.74-2.93-.84-4.18-3.75-3.09a1.21,1.21,0,0,1-.81.11c-.84-.27-.24-1.51.31-2.2a5.93,5.93,0,0,0,.7-5.69c-.16-.44,8.06-.63,9-.14,3.17,1.74,1.1,8.49,4.78,7.35.24-2.57.11-5.23.12-7.82l3.75-.14c-.93,0-.38-4.76-.06-5.28,1.23-2,5-1.17,4.69-5-.42-4.86-9.84-5.85-8.71-.27a24.51,24.51,0,0,1-9.29,1.25c-.07,1-.13,2-.19,3a2.69,2.69,0,0,1-2.42.19,7.43,7.43,0,0,1,.54-8.2c-1.08-1.65.23-3.77,1.49-5.29-3.44-2.52-2.45-8.92,1.59-10.28s8.71,3.14,7.49,7.23a9.51,9.51,0,0,1,5.33,2.44,12.48,12.48,0,0,1,9.12-11.25c2.52-.65,5.51-.61,7.23-2.57.77-.86,1.15-2,1.86-2.92,1.61-2,4.49-2.46,7.09-2.61q2.61-.14,5.22-.09a131.75,131.75,0,0,1-49.17,74.57,5.17,5.17,0,0,1-2.66-.39c-1.48-.8-1.94-2.66-2.24-4.31-1.19-6.43-.52-10.43,4.71-14.42A4.84,4.84,0,0,1,328.65,329.32Z",
    style: {
      fill: "#f5f5f5",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.79,173.24a7.62,7.62,0,0,0-7.62-7.62A7.47,7.47,0,0,0,395,166a16.53,16.53,0,0,0,.17-2.34,16.11,16.11,0,0,0-19.1-15.85,14.09,14.09,0,0,0-26.13,7.13l-.23,0a13,13,0,0,0,0,26h47.69A7.61,7.61,0,0,0,404.79,173.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,197.65a6.52,6.52,0,0,0-8.41-6.25,13.4,13.4,0,0,0,.15-2,13.83,13.83,0,0,0-13.83-13.83,14.31,14.31,0,0,0-2.55.24,12.08,12.08,0,0,0-22.41,6.11h-.2a11.14,11.14,0,0,0,0,22.28h40.9A6.53,6.53,0,0,0,147,197.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,257.14a7.62,7.62,0,0,0-9.8-7.29,16.31,16.31,0,0,0,.17-2.34,16.1,16.1,0,0,0-19.09-15.84,14.09,14.09,0,0,0-26.13,7.12h-.24a13,13,0,0,0,0,26h47.69A7.61,7.61,0,0,0,295.21,257.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.77,327.87a5.28,5.28,0,0,0-5.28-5.28,5,5,0,0,0-1.51.23,12.36,12.36,0,0,0,.11-1.62A11.17,11.17,0,0,0,394.92,310a11.6,11.6,0,0,0-2.06.19,9.77,9.77,0,0,0-18.12,4.94h-.16a9,9,0,0,0,0,18h33.06A5.27,5.27,0,0,0,412.77,327.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.24,331.68a4.94,4.94,0,0,0-4.93-4.94,5.08,5.08,0,0,0-1.42.21,10.73,10.73,0,0,0,.11-1.51A10.46,10.46,0,0,0,111.54,315a10.08,10.08,0,0,0-1.92.18,9.14,9.14,0,0,0-17,4.62h-.15a8.43,8.43,0,1,0,0,16.85h30.93A4.93,4.93,0,0,0,128.24,331.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.54,289.65a.9.9,0,0,1-.84-.58c-6.22-16.42,4.6-38.1,30.47-61,25.66-22.75,63.12-44.12,105.47-60.17S310.1,143,344.36,143h.13c34.58,0,57.06,9.08,63.28,25.51a.9.9,0,0,1-1.68.63c-12.38-32.67-93-32.48-179.81.41-42.16,16-79.42,37.23-104.91,59.83-25.28,22.41-35.93,43.39-30,59.06a.89.89,0,0,1-.52,1.16A.87.87,0,0,1,90.54,289.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.39,370.16a.9.9,0,0,1-.54-1.62c13.48-10,15.86-33.38,6.71-65.9-9.22-32.8-29.07-70.82-55.9-107.06C244.46,121,176.7,77.23,148.62,98a.9.9,0,1,1-1.07-1.45c14.12-10.45,37.92-5.91,67,12.77,28.86,18.52,59.59,48.77,86.54,85.17s46.9,74.64,56.18,107.65c9.37,33.29,6.75,57.37-7.37,67.82A.89.89,0,0,1,349.39,370.16Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-20"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-20",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.7,244.76a6.06,6.06,0,0,0-5.08,4.09l-43.12-7.34a10.12,10.12,0,0,0,0-2.13,10.5,10.5,0,0,0-11.58-9.27c-.27,0-.53.08-.79.12-3-10.46-7.63-26.93-11.14-39.38a6.07,6.07,0,1,0-1.92.55c1.5,5.32,3.84,13.62,6.19,21.92,1.77,6.26,3.53,12.49,4.95,17.47a10.49,10.49,0,0,0-6.56,10.9,9.88,9.88,0,0,0,.71,2.78L272.05,262a13.58,13.58,0,0,0-18.65-4.77l-36.32-52.09a19.46,19.46,0,0,0-6.52-34.08L217.37,142a6.39,6.39,0,0,0,1.07,0,6.1,6.1,0,1,0-3-.44l-6.81,29.1a19.08,19.08,0,0,0-5.61-.2,19.5,19.5,0,0,0-17.22,21.51c.06.51.16,1,.25,1.52l-42.8,10.51a10.47,10.47,0,1,0,.53,2.3c0-.12,0-.24-.06-.36l42.81-10.51a19.41,19.41,0,0,0,28.93,10.9l36.32,52.09a13.59,13.59,0,0,0,3.62,23.23l-8.91,28.85a10.5,10.5,0,0,0-12.55,11.43,10.07,10.07,0,0,0,.47,2.14L213,333.46a6.06,6.06,0,1,0,1,2.66,5.79,5.79,0,0,0-.16-.83l21.43-9.45a10.51,10.51,0,0,0,10.31,5.3,10.36,10.36,0,0,0,6.62-3.41l25.69,19.06a6,6,0,0,0-.64,3.44,6.1,6.1,0,1,0,1.83-5.05l-25.68-19.05A10.47,10.47,0,0,0,248.38,311l8.91-28.86a13.79,13.79,0,0,0,4.55.28,13.61,13.61,0,0,0,11.1-18.68l35.32-17.54a10.48,10.48,0,0,0,18.86-2.76l43.17,7.35c0,.21,0,.43,0,.64a6.09,6.09,0,1,0,5.38-6.71Zm-74.77-63.47a4.08,4.08,0,1,1-3.61,4.51A4.1,4.1,0,0,1,300.93,181.29Zm-79.11-45.85a4.08,4.08,0,1,1-4.51-3.61A4.09,4.09,0,0,1,221.82,135.44Zm-80,71a8.5,8.5,0,1,1-9.38-7.5A8.51,8.51,0,0,1,141.78,206.46Zm46-14.77a17.48,17.48,0,1,1,19.31,15.45A17.5,17.5,0,0,1,187.77,191.69Zm24.16,144.66a4.08,4.08,0,1,1-4.51-3.61A4.09,4.09,0,0,1,211.93,336.35Zm33.35-7.19a8.5,8.5,0,1,1,7.51-9.38A8.5,8.5,0,0,1,245.28,329.16Zm37.49,16.34a4.08,4.08,0,1,1-3.61,4.51A4.09,4.09,0,0,1,282.77,345.5Zm-10.88-77.86a11.62,11.62,0,1,1-12.83-10.27A11.64,11.64,0,0,1,271.89,267.64Zm36.72-26.17A8.49,8.49,0,1,1,318,249,8.51,8.51,0,0,1,308.61,241.47Zm63.7,9.78a4.08,4.08,0,1,1,4.51,3.61A4.09,4.09,0,0,1,372.31,251.25Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.7,244.76a6.06,6.06,0,0,0-5.08,4.09l-43.12-7.34a10.12,10.12,0,0,0,0-2.13,10.5,10.5,0,0,0-11.58-9.27c-.27,0-.53.08-.79.12-3-10.46-7.63-26.93-11.14-39.38a6.07,6.07,0,1,0-1.92.55c1.5,5.32,3.84,13.62,6.19,21.92,1.77,6.26,3.53,12.49,4.95,17.47a10.49,10.49,0,0,0-6.56,10.9,9.88,9.88,0,0,0,.71,2.78L272.05,262a13.58,13.58,0,0,0-18.65-4.77l-36.32-52.09a19.46,19.46,0,0,0-6.52-34.08L217.37,142a6.39,6.39,0,0,0,1.07,0,6.1,6.1,0,1,0-3-.44l-6.81,29.1a19.08,19.08,0,0,0-5.61-.2,19.5,19.5,0,0,0-17.22,21.51c.06.51.16,1,.25,1.52l-42.8,10.51a10.47,10.47,0,1,0,.53,2.3c0-.12,0-.24-.06-.36l42.81-10.51a19.41,19.41,0,0,0,28.93,10.9l36.32,52.09a13.59,13.59,0,0,0,3.62,23.23l-8.91,28.85a10.5,10.5,0,0,0-12.55,11.43,10.07,10.07,0,0,0,.47,2.14L213,333.46a6.06,6.06,0,1,0,1,2.66,5.79,5.79,0,0,0-.16-.83l21.43-9.45a10.51,10.51,0,0,0,10.31,5.3,10.36,10.36,0,0,0,6.62-3.41l25.69,19.06a6,6,0,0,0-.64,3.44,6.1,6.1,0,1,0,1.83-5.05l-25.68-19.05A10.47,10.47,0,0,0,248.38,311l8.91-28.86a13.79,13.79,0,0,0,4.55.28,13.61,13.61,0,0,0,11.1-18.68l35.32-17.54a10.48,10.48,0,0,0,18.86-2.76l43.17,7.35c0,.21,0,.43,0,.64a6.09,6.09,0,1,0,5.38-6.71Zm-74.77-63.47a4.08,4.08,0,1,1-3.61,4.51A4.1,4.1,0,0,1,300.93,181.29Zm-79.11-45.85a4.08,4.08,0,1,1-4.51-3.61A4.09,4.09,0,0,1,221.82,135.44Zm-80,71a8.5,8.5,0,1,1-9.38-7.5A8.51,8.51,0,0,1,141.78,206.46Zm46-14.77a17.48,17.48,0,1,1,19.31,15.45A17.5,17.5,0,0,1,187.77,191.69Zm24.16,144.66a4.08,4.08,0,1,1-4.51-3.61A4.09,4.09,0,0,1,211.93,336.35Zm33.35-7.19a8.5,8.5,0,1,1,7.51-9.38A8.5,8.5,0,0,1,245.28,329.16Zm37.49,16.34a4.08,4.08,0,1,1-3.61,4.51A4.09,4.09,0,0,1,282.77,345.5Zm-10.88-77.86a11.62,11.62,0,1,1-12.83-10.27A11.64,11.64,0,0,1,271.89,267.64Zm36.72-26.17A8.49,8.49,0,1,1,318,249,8.51,8.51,0,0,1,308.61,241.47Zm63.7,9.78a4.08,4.08,0,1,1,4.51,3.61A4.09,4.09,0,0,1,372.31,251.25Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.68,390.19c0-.28-.94-27.66-5.38-32-4.28-4.16-9.21-.15-9.42,0l-.54-.66c.05,0,5.72-4.67,10.55,0s5.6,31.41,5.63,32.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,395.58c-.13-1.34-3.05-32.94,8.87-46.62l.64.55c-11.68,13.41-8.7,45.66-8.67,46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.77,392.13l-.85-.05c0-.37,2.33-37-6.37-45l.57-.62C388.12,354.72,385.87,390.61,385.77,392.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.91,392.11h-.85c0-1,.29-24.81,7.07-28.7a4.83,4.83,0,0,1,4.44-.43c4.11,1.7,6.14,9,6.23,9.31l-.82.22c0-.07-2-7.21-5.74-8.75a4,4,0,0,0-3.69.38C387.19,367.78,386.91,391.86,386.91,392.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.28,392.13l-.85-.05c0-.19,1-18.75-4-25.28-1.2-1.56-2.51-2.32-3.87-2.21-3.24.22-6,5-6,5.05l-.74-.42c.12-.21,3-5.22,6.69-5.48,1.67-.11,3.22.74,4.6,2.55C385.31,373.06,384.32,391.35,384.28,392.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,394.66c-.14-1.81-3.28-44.28,2.26-51.78l.68.5c-5.36,7.25-2.13,50.77-2.1,51.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,367.34s-3.32,1.22-2.33,4.11,11.48,7.64,11.48,7.64,4.39-4,.35-10.58S399.13,365.27,399,367.34Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,367.34s-3.32,1.22-2.33,4.11,11.48,7.64,11.48,7.64,4.39-4,.35-10.58S399.13,365.27,399,367.34Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,361.84s3.53-.15,3.73,2.9-7.65,11.47-7.65,11.47-5.61-2-4.4-9.63S383.74,360,384.62,361.84Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,361.84s3.53-.15,3.73,2.9-7.65,11.47-7.65,11.47-5.61-2-4.4-9.63S383.74,360,384.62,361.84Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,347.27s2.35-.26,2.16-1.69-9.15-5.13-14.44.84c0,0,3.39,5.82,8.28,5.9S381.63,347.27,381.63,347.27Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,347.27s2.35-.26,2.16-1.69-9.15-5.13-14.44.84c0,0,3.39,5.82,8.28,5.9S381.63,347.27,381.63,347.27Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,343.78s-2.14,1-2.73-.28,5.06-9.2,12.7-6.93c0,0,.21,6.73-3.91,9.39S386,343.78,386,343.78Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,343.78s-2.14,1-2.73-.28,5.06-9.2,12.7-6.93c0,0,.21,6.73-3.91,9.39S386,343.78,386,343.78Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,366.18s1.62-1.32-.13-2-10.37-.46-10.45,8.07c0,0,10,1.67,11.26-1.58S374.87,366.18,374.87,366.18Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,366.18s1.62-1.32-.13-2-10.37-.46-10.45,8.07c0,0,10,1.67,11.26-1.58S374.87,366.18,374.87,366.18Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,347.05s-1.63-1.31.13-1.95,10.36-.46,10.45,8.07c0,0-10,1.66-11.27-1.58S395.31,347.05,395.31,347.05Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,347.05s-1.63-1.31.13-1.95,10.36-.46,10.45,8.07c0,0-10,1.66-11.27-1.58S395.31,347.05,395.31,347.05Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,353.92s-.14-1.59,1.14-1,5.78,5.47,1.13,10.06c0,0-6.26-4.64-5.14-7.05S390,353.92,390,353.92Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,353.92s-.14-1.59,1.14-1,5.78,5.47,1.13,10.06c0,0-6.26-4.64-5.14-7.05S390,353.92,390,353.92Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,356.2s1-1.28-.45-1.44-7.8,1.55-6.31,7.91c0,0,7.76-.58,8.1-3.22S373.41,356.2,373.41,356.2Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,356.2s1-1.28-.45-1.44-7.8,1.55-6.31,7.91c0,0,7.76-.58,8.1-3.22S373.41,356.2,373.41,356.2Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.66 415.74 373 415.74 370.13 386.55 402.54 386.55 399.66 415.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.66 415.74 373 415.74 370.13 386.55 402.54 386.55 399.66 415.74",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.7,
    y: 383.33,
    width: 35.26,
    height: 6.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.7,
    y: 383.33,
    width: 35.26,
    height: 6.44,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.72,358H322.85a6.55,6.55,0,0,1-6.63-7.27L333,159.1a8.09,8.09,0,0,1,7.9-7.27h64.88a6.56,6.56,0,0,1,6.63,7.27L395.63,350.68A8.1,8.1,0,0,1,387.72,358Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.72,358H322.85a6.55,6.55,0,0,1-6.63-7.27L333,159.1a8.09,8.09,0,0,1,7.9-7.27h64.88a6.56,6.56,0,0,1,6.63,7.27L395.63,350.68A8.1,8.1,0,0,1,387.72,358Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.73,358H315.86a6.56,6.56,0,0,1-6.63-7.27L326,159.1a8.09,8.09,0,0,1,7.9-7.27h64.88a6.56,6.56,0,0,1,6.63,7.27L388.64,350.68A8.1,8.1,0,0,1,380.73,358Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.73,358H315.86a6.56,6.56,0,0,1-6.63-7.27L326,159.1a8.09,8.09,0,0,1,7.9-7.27h64.88a6.56,6.56,0,0,1,6.63,7.27L388.64,350.68A8.1,8.1,0,0,1,380.73,358Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.75,158.74,386,350.67c-.14,1.58-1.12,2.81-2.22,2.81H313.43c-1,0-1.67-1.13-1.54-2.58l16.83-192.39c.11-1.26.85-2.36,1.72-2.36H348c.49,0,.9.47,1,1.14l.5,2.59c.13.67.54,1.13,1,1.13h29.93a1.47,1.47,0,0,0,1.23-1.11l1-2.6a1.53,1.53,0,0,1,1.23-1.15h17.32C402.21,156.15,402.87,157.35,402.75,158.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.93 168.15 399.88 191.59 399.78 192.69 398.14 211.47 398.08 212.16 397.82 215.1 397.24 221.75 396.79 226.84 396.73 227.53 396.35 231.94 395.75 238.81 394.56 252.43 394.46 253.53 387.52 332.83 313.47 332.83 327.88 168.15 401.93 168.15",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.41 163.89 337.32 163.89 337.48 162.13 336.56 162.13 336.41 163.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.92 163.89 335.83 163.89 336.04 161.54 335.13 161.54 334.92 163.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.43 163.89 334.34 163.89 334.6 160.95 333.69 160.95 333.43 163.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.94 163.89 332.85 163.89 333.16 160.37 332.25 160.37 331.94 163.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.98 163.24 393.44 163.24 393.59 161.49 394.13 161.49 393.98 163.24",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.29 163.89 398.61 163.89 398.88 160.84 394.56 160.84 394.29 163.89",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.92,156.4c-.07.81-.58,1.47-1.15,1.47s-1-.66-.88-1.47.58-1.46,1.14-1.46S366,155.59,365.92,156.4Z",
    style: {
      fill: "#263238",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,156.4c-.05.52-.38.94-.74.94s-.61-.42-.57-.94.38-.94.74-.94S368,155.89,368,156.4Z",
    style: {
      fill: "#263238",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "399.88 191.59 399.78 192.69 398.14 211.47 398.08 212.16 397.82 215.1 397.24 221.75 396.79 226.84 396.73 227.53 396.35 231.94 395.75 238.81 394.56 252.43 394.46 253.53 346.28 253.53 346.28 191.59 399.88 191.59"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "399.78 192.69 398.14 211.47 398.08 212.16 397.82 215.1 397.24 221.75 396.79 226.84 396.73 227.53 396.35 231.94 395.75 238.81 394.56 252.43 347.38 252.43 347.38 192.69 399.78 192.69",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "392.3 227.53 392.3 231.94 396.35 231.94 395.75 238.81 386.13 238.81 386.13 231.94 391.61 231.94 391.61 226.84 396.79 226.84 396.73 227.53 392.3 227.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.84 215.1 397.82 215.1 397.24 221.75 392.84 221.75 392.84 215.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.14 211.47 398.08 212.16 387.36 212.16 384.83 214.69 382.31 212.16 366.24 212.16 366.24 216.51 376.97 216.51 376.97 225.4 366.24 225.4 366.24 235.38 372.04 235.38 372.04 241.87 359.74 241.87 359.74 235.38 365.55 235.38 365.55 225.4 357.71 225.4 357.71 216.51 365.55 216.51 365.55 211.47 382.74 211.47 384.49 209.72 384.49 206.54 375.94 206.54 375.94 200.41 393.72 200.41 393.72 206.54 385.18 206.54 385.18 209.72 386.93 211.47 398.14 211.47",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.32,212.4s-5.1,2.85-2.28,9.41c0,0-3.76,2.73-2.12,8.37s5,5.8,5,5.8a12.24,12.24,0,0,0-.76,8.77,7,7,0,0,0,5.2,5s-3.57,6.78,2.36,11.38c12.48,9.67,28.8,3.4,33.85-1,7.71-6.77,4-13.58,4-13.58s3.62-4.93-3.43-13c0,0,4.23-6.09-2-13.32,0,0,3.06-9.95-8.06-12.45,0,0-1.51-4.76-6.25-6.07-6.18-1.71-8.51,1.31-8.51,1.31-8.36-2.82-10.23,2.71-10.23,2.71S334,205.66,334.32,212.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.87,261.88c0,1.44,0,2.69-.12,4s-.17,2.6-.29,3.9c-.23,2.6-.62,5.17-1,7.75a83.23,83.23,0,0,1-4,15.21l-.35.93c-.13.34-.18.53-.46,1.17a7.83,7.83,0,0,1-2.39,2.95A8,8,0,0,1,330,299.2a10.6,10.6,0,0,1-2.79.21,18.46,18.46,0,0,1-4.53-.82,35.79,35.79,0,0,1-3.9-1.44,69,69,0,0,1-13.41-8.09l2.34-3.68c2.17,1,4.44,2.08,6.68,3a60.87,60.87,0,0,0,6.73,2.47,20.15,20.15,0,0,0,6.17,1.08c.83,0,1.3-.32,1.16-.31s-.12.08-.11,0,.1-.34.18-.6l.26-.85a99.46,99.46,0,0,0,3-14c.35-2.39.6-4.79.82-7.19.11-1.2.21-2.4.28-3.6s.13-2.44.16-3.51Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,251.82c-3.47,1.15-4.88,15.89-4.88,15.89l10.22,5.92s8.28-15.36,5.28-19C342.62,250.73,340.2,250.13,335.13,251.82Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.13,251.82c-3.47,1.15-4.88,15.89-4.88,15.89l10.22,5.92s8.28-15.36,5.28-19C342.62,250.73,340.2,250.13,335.13,251.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "335.69 255.04 334.04 269.91 339.79 273.23 335.69 255.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,289.74l-10.5-.57,5.71-6.63s5.4,1.13,6.41,4.56Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.64 285.81 296.04 280.96 302.79 282.54 297.08 289.17 291.64 285.81",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.85,300.77,343,303.3c-11.85-49.75-7.86-51.49-7.86-51.49s1.28-.36,3.24-.86c2.84-.72,7.12-1.73,11.1-2.39a109.94,109.94,0,0,1,15.83-1.15,95.09,95.09,0,0,1,10.36.37c2.76.24,4.58.5,4.58.5C375.58,277.88,376.24,286.63,377.85,300.77Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377,274.2a125.34,125.34,0,0,0,.84,26.57L343,303.3c-11.85-49.75-7.86-51.49-7.86-51.49s1.28-.36,3.24-.86c2.84-.72,7.12-1.73,11.1-2.39a109.94,109.94,0,0,1,15.83-1.15,95.09,95.09,0,0,1,10.36.37c2.76.24,4.58.5,4.58.5-1,6.51-1.8,12-2.36,16.78C377.5,268.44,377.21,271.46,377,274.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.7,332.83c-1.12-13.06-2.6-24.64-6.85-32.06l-25.65,1.87-9.2.67s-.38,12.88-.6,29.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.7,332.83c-1.12-13.06-2.6-24.64-6.85-32.06l-25.65,1.87-9.2.67s-.38,12.88-.6,29.52Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.44,230.71c-.63,5.16-.95,14.57,2.86,17.7,0,0-1,5.27-10.48,6-10.4.75-5.34-4.8-5.34-4.8,5.58-1.77,5.12-6,3.85-9.86Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.72,234.38l-5.39,5.33a15.37,15.37,0,0,1,.69,2.77c2.15-.47,5-3.07,5-5.36A7.55,7.55,0,0,0,356.72,234.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.21,218.26c1,8.48,1.59,12.05-1.88,17.12-5.21,7.62-15.84,7-19.35-1-3.15-7.21-4.24-19.87,3.37-24.68A11.65,11.65,0,0,1,360.21,218.26Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.08,213.16c-1.3,4.61,29.22,9,23.65,1.26S340.5,201.12,337.08,213.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,217.24c.75,4,7.4,6.72,7.4,6.72s4.73-7.08-.24-8.15S353.3,217.24,353.3,217.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,223.08c.12.68-.14,1.3-.59,1.38s-.91-.41-1-1.09.14-1.3.59-1.38S346.59,222.39,346.71,223.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,224.46c.12.69-.14,1.3-.59,1.38s-.91-.4-1-1.09.14-1.3.59-1.38S338.87,223.78,339,224.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.16,223.37l-1.72-.17S337.51,224.33,338.16,223.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,225.08a18.43,18.43,0,0,1-1.65,4.79,3,3,0,0,0,2.51,0Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.86,225.55a6.22,6.22,0,0,1-2.59,4c-1.81,1.23-3.41-.22-3.49-2.29-.07-1.87.79-4.75,2.88-5.16A2.81,2.81,0,0,1,363.86,225.55Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.53,221a.41.41,0,0,1-.46-.14c-1.14-1.51-3.56-1.45-3.59-1.45a.41.41,0,0,1-.42-.39.4.4,0,0,1,.4-.42c.11,0,2.87-.07,4.26,1.77a.41.41,0,0,1-.08.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,221.31a.42.42,0,0,1-.4-.07.41.41,0,0,1,0-.58,4,4,0,0,1,3.4-1.49.41.41,0,1,1-.1.81h0a3.21,3.21,0,0,0-2.68,1.21A.36.36,0,0,1,336,221.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,222l-1.72-.18S345.23,222.94,345.88,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,232.19a24.93,24.93,0,0,1,2.56,2.56c.18-.11.37-.22.54-.34,2.45-1.54,3.08-3.06,3-4.28a3.79,3.79,0,0,0-.52-1.69,3.74,3.74,0,0,0-.61-.81c-.81,1.59-3,3.21-4.17,4C345.35,232,345,232.19,345,232.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.85,231.65l.77.74c2.3-1.46,3.73-2.8,4-3.95a3.74,3.74,0,0,0-.61-.81C349.21,229.22,347,230.84,345.85,231.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.12,234.41c2.45-1.54,3.08-3.06,3-4.28a9.32,9.32,0,0,0-2.38,2.25A3.58,3.58,0,0,0,348.12,234.41Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.22,298.69l1.12,3.06c.14.23-.13.5-.53.53l-35.87,2.6c-.31,0-.58-.11-.62-.31l-.54-3.09c0-.22.22-.42.57-.44l35.29-2.57A.62.62,0,0,1,378.22,298.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,303l.94-.07c.19,0,.33-.12.31-.24l-.74-4c0-.11-.19-.2-.38-.19l-.95.07c-.19,0-.32.12-.3.24l.74,4C373.41,302.91,373.58,303,373.77,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,305l.95-.07c.19,0,.32-.12.3-.24l-.74-4c0-.12-.19-.2-.38-.19l-.94.07c-.19,0-.33.12-.31.24l.74,4C345.26,305,345.43,305,345.62,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,304l.94-.06c.19,0,.33-.13.3-.24l-.73-4a.35.35,0,0,0-.39-.19l-.94.07c-.19,0-.33.12-.3.24l.73,4A.36.36,0,0,0,359.7,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.77,303l.94-.07c.19,0,.33-.12.31-.24l-.74-4c0-.11-.19-.2-.38-.19l-.95.07c-.19,0-.32.12-.3.24l.74,4C373.41,302.91,373.58,303,373.77,303Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,305l.95-.07c.19,0,.32-.12.3-.24l-.74-4c0-.12-.19-.2-.38-.19l-.94.07c-.19,0-.33.12-.31.24l.74,4C345.26,305,345.43,305,345.62,305Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,304l.94-.06c.19,0,.33-.13.3-.24l-.73-4a.35.35,0,0,0-.39-.19l-.94.07c-.19,0-.33.12-.3.24l.73,4A.36.36,0,0,0,359.7,304Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,290.15l-8.86,2.8,3.36-8.08s5.49-.6,7.51,2.35Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.15 290.42 357.33 283.81 364.29 284.87 360.93 292.95 354.15 290.42",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.67,247.78a36.76,36.76,0,0,1-8.34,7.72c-.31.21-.63.41-1,.61a24.11,24.11,0,0,1-13.74,3.71c-4.94-.22-8.17-1.36-10.29-2.8a10.66,10.66,0,0,1-.88-.67,8.54,8.54,0,0,1-3.08-5.4c1.47-.37,3.33-.83,5.34-1.27l1.24-.26c1.49-.31,3-.61,4.52-.86a109.94,109.94,0,0,1,15.83-1.15c.43,0,.86,0,1.28,0h1C370.6,247.41,373.44,247.59,375.67,247.78Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.33,255.5c-.31.21-.63.41-1,.61a44.16,44.16,0,0,1,.22-8.71h1A45,45,0,0,0,367.33,255.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,249.42a35.68,35.68,0,0,0-2.62,7.6,10.66,10.66,0,0,1-.88-.67,36.11,36.11,0,0,1,2.26-6.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.89,265.06c-.39,3.38-.68,6.4-.88,9.14-3-3.63-4.36-10.07-4.36-10.07A6.34,6.34,0,0,1,377.89,265.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.68,257.19c2,4,3.8,7.92,5.47,12,.83,2.06,1.64,4.13,2.35,6.3.35,1.09.7,2.18,1,3.35a24.29,24.29,0,0,1,.72,3.91l0,.66v.34l0,.42a6.66,6.66,0,0,1-.13,1,5.53,5.53,0,0,1-.45,1.26,6.6,6.6,0,0,1-2.61,2.73,13.77,13.77,0,0,1-4.16,1.49,40,40,0,0,1-7,.72,84.34,84.34,0,0,1-13.33-.86l.16-4.35c4.22-.39,8.5-.82,12.58-1.46a42.86,42.86,0,0,0,5.77-1.26,6.58,6.58,0,0,0,1.86-.85c.12-.08,0-.13-.37.44a4.26,4.26,0,0,0-.24.71v0l0-.06,0-.15a18,18,0,0,0-.67-2.41c-.29-.91-.65-1.86-1-2.81-.76-1.9-1.58-3.83-2.42-5.76-1.73-3.83-3.56-7.72-5.34-11.53Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,248.29c3.57.81,8.64,12.52,8.64,12.52L376,271.48s-5.67-9.67-4.53-14.29C372.69,252.37,376.17,247.37,380.24,248.29Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.24,248.29c3.57.81,8.64,12.52,8.64,12.52L376,271.48s-5.67-9.67-4.53-14.29C372.69,252.37,376.17,247.37,380.24,248.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.33,255.5c-.31.21-.63.41-1,.61a44.16,44.16,0,0,1,.22-8.71h1A45,45,0,0,0,367.33,255.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345,249.42a35.68,35.68,0,0,0-2.62,7.6,10.66,10.66,0,0,1-.88-.67,36.11,36.11,0,0,1,2.26-6.67Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.9,288.83H84.75A4.29,4.29,0,0,0,80.41,294L97.24,400.05a6.28,6.28,0,0,0,6,5.16H251.37a4.29,4.29,0,0,0,4.34-5.16L238.88,294A6.27,6.27,0,0,0,232.9,288.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,288.83H84.75A4.29,4.29,0,0,0,80.41,294L97.24,400.05a6.28,6.28,0,0,0,6,5.16H251.37a4.29,4.29,0,0,0,4.34-5.16L238.88,294A6.27,6.27,0,0,0,232.9,288.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.9,288.83H85.75A4.29,4.29,0,0,0,81.41,294L98.24,400.05a6.28,6.28,0,0,0,6,5.16H252.37a4.29,4.29,0,0,0,4.34-5.16L239.88,294A6.27,6.27,0,0,0,233.9,288.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16,396.8H100.76l-1.06-6.71-1.3-8.18-.76-4.76-1-6.2-2.14-13.5-.34-2.16-1.3-8.18-.75-4.76-3.46-21.79-1.31-8.25-.81-5.12-2.17-13.68a1.51,1.51,0,0,1,.27-1.25,1.39,1.39,0,0,1,1.1-.43H233.91a3.26,3.26,0,0,1,3,2.62Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16,396.8H100.76l-1.06-6.71-1.3-8.18-.76-4.76-1-6.2-2.14-13.5-.34-2.16-1.3-8.18-.75-4.76-3.46-21.79-1.31-8.25-.81-5.12-2.17-13.68a1.51,1.51,0,0,1,.27-1.25,1.39,1.39,0,0,1,1.1-.43H233.91a3.26,3.26,0,0,1,3,2.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.44 307.19 188.44 396.8 100.76 396.8 99.7 390.09 98.4 381.91 97.64 377.15 96.66 370.95 94.52 357.45 94.18 355.29 92.88 347.11 92.13 342.35 88.67 320.56 87.36 312.31 86.55 307.19 188.44 307.19",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.52 312.31 184.52 342.35 92.13 342.35 88.67 320.56 87.36 312.31 184.52 312.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.52 347.11 184.52 377.15 97.64 377.15 96.66 370.95 94.52 357.45 94.18 355.29 92.88 347.11 184.52 347.11",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.52 381.91 184.52 396.8 100.76 396.8 99.7 390.09 98.4 381.91 184.52 381.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.73,
    y: 317.17,
    width: 5.86,
    height: 25.18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.06,
    y: 316.86,
    width: 5.86,
    height: 25.18,
    transform: "translate(-53.82 29.75) rotate(-9.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.52 320.49 94.52 342.35 92.13 342.35 88.67 320.56 88.67 320.49 94.52 320.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.13,
    y: 320.49,
    width: 5.86,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.11,
    y: 320.49,
    width: 5.86,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.86,
    y: 320.11,
    width: 5.86,
    height: 21.86,
    transform: "translate(-68.88 34.52) rotate(-12.53)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.66,
    y: 315.92,
    width: 2.93,
    height: 26.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 315.92,
    width: 2.93,
    height: 26.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.66,
    y: 351.97,
    width: 5.86,
    height: 25.18,
    transform: "translate(363.17 729.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.34,
    y: 351.97,
    width: 5.86,
    height: 25.18,
    transform: "translate(306.53 729.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 351.66,
    width: 5.86,
    height: 25.18,
    transform: "translate(174.27 743.4) rotate(-170.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 355.29,
    width: 5.86,
    height: 21.86,
    transform: "translate(348.66 732.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.94,
    y: 355.29,
    width: 5.86,
    height: 21.86,
    transform: "translate(321.73 732.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.95,
    y: 355.29,
    width: 5.86,
    height: 21.86,
    transform: "translate(253.77 732.44) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.2,
    y: 354.92,
    width: 5.86,
    height: 21.86,
    transform: "translate(203.5 754.03) rotate(-167.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.33,
    y: 350.72,
    width: 2.93,
    height: 26.43,
    transform: "translate(335.6 727.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 350.72,
    width: 2.93,
    height: 26.43,
    transform: "translate(265.92 727.87) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.13,
    y: 355.29,
    width: 5.86,
    height: 21.86,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.59 350.72 99.59 377.15 97.64 377.15 96.66 370.95 96.66 350.72 99.59 350.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.59,
    y: 386.77,
    width: 5.86,
    height: 10.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.44 396.8 174.49 396.8 172.83 387.14 178.6 386.14 180.44 396.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.53,
    y: 390.09,
    width: 5.85,
    height: 6.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.99,
    y: 390.09,
    width: 5.86,
    height: 6.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.97,
    y: 390.09,
    width: 5.86,
    height: 6.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.8 396.8 149.8 396.8 148.42 390.61 154.14 389.34 155.8 396.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.52,
    y: 385.52,
    width: 2.93,
    height: 11.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.36,
    y: 385.52,
    width: 2.93,
    height: 11.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.05 396.8 107.11 396.8 105.44 387.14 111.21 386.14 113.05 396.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.44 390.09 105.44 396.8 100.76 396.8 99.7 390.09 105.44 390.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.68,327l.8.69.91.75,1.87,1.52c1.26,1,2.56,2,3.88,2.9a89.4,89.4,0,0,0,8.1,5.13c1.38.78,2.77,1.48,4.17,2.12s2.81,1.24,4.22,1.73a34.14,34.14,0,0,0,4.23,1.22,25.24,25.24,0,0,0,4.15.62l1,.06s0,0,0,.05,0,.07.22,0A5.18,5.18,0,0,0,224,342a31.89,31.89,0,0,0,3.4-8.1,139,139,0,0,0,3.9-19.7h7.07a91.36,91.36,0,0,1,.47,10.94,82.61,82.61,0,0,1-.87,11.09,56.61,56.61,0,0,1-1.21,5.71,31,31,0,0,1-2.26,6,17.78,17.78,0,0,1-4.93,6.15,13,13,0,0,1-4.52,2.2,12.73,12.73,0,0,1-2.57.41l-.47,0h-.4l-.8,0a41.64,41.64,0,0,1-12.24-1.78,60.8,60.8,0,0,1-10.9-4.37,79.07,79.07,0,0,1-9.76-5.9c-1.55-1.08-3.05-2.21-4.53-3.39-.74-.59-1.47-1.18-2.19-1.8l-1.09-1-1.15-1.07Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.77,338.12l-7,17.2s-.81-.24-2.18-.69c-1-.33-2.31-.77-3.84-1.3-8.59-3-22.47-9.63-25.79-15-4.95-8,2.66-14.2,17-11.66,6.18,1.1,11.85,5.7,16.11,8.09,1.4.79,2.61,1.5,3.55,2.05C212,337.63,212.77,338.12,212.77,338.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,339.33c1.73-3.64,6.81,0,15,.71,3.66.32,16.53,9,17.68,12l-1.34,3.31S179.26,347.36,174.47,339.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,318.27l9.23-5.69L237.23,306s-7.8,6.72-6.22,9.53Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.93 303.02 240.14 299.87 237.23 305.96 245.28 312.58 246.93 303.02",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,374.13c1.2,8.61,1.91,16.37,2.41,22.67h51.87C201.13,350,188,326.21,188,326.21s-2-.38-5.3-.72c-2.59-.25-5.84-.48-9.14-.47a185.61,185.61,0,0,0-21.29,2.05c-3.7.53-7.45,1.35-10.42,2.08-3.59.88-6.08,1.65-6.08,1.65.34,1,.66,2,1,2.95A237.82,237.82,0,0,1,145.61,374.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,374.13a238.24,238.24,0,0,0-8.91-40.38c3.32-.61,9.08-.83,10.55,4.48C148.83,344,148.86,357.74,145.61,374.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11,343.52c-.56,1.18-1.19,2.59-1.78,3.91s-1.19,2.69-1.76,4.05c-1.14,2.71-2.26,5.43-3.27,8.17a109.49,109.49,0,0,0-4.92,16.45l-.38,2a3,3,0,0,0-.11-.86,3.49,3.49,0,0,0-.59-1.25,2.49,2.49,0,0,0-.72-.66c-.15-.1-.26-.1-.23-.07a1.81,1.81,0,0,0,.79.33,17.9,17.9,0,0,0,3.44.45c1.31.08,2.71.07,4.13,0,5.7-.18,11.78-1,17.71-1.68l1.94,6.8a93.17,93.17,0,0,1-9,3.31,87.1,87.1,0,0,1-9.42,2.41c-1.63.29-3.3.55-5.07.71a27.07,27.07,0,0,1-5.75,0,14.85,14.85,0,0,1-3.66-.89,11,11,0,0,1-2.24-1.17,9.69,9.69,0,0,1-2.34-2.29,9.35,9.35,0,0,1-1.5-3.35,10.3,10.3,0,0,1-.2-3.16l.26-2.57c.08-.85.21-1.68.34-2.51s.23-1.66.4-2.47c.33-1.62.64-3.26,1-4.84.74-3.2,1.69-6.3,2.69-9.37s2.15-6.07,3.37-9c.62-1.49,1.25-3,1.93-4.42s1.35-2.86,2.17-4.43Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,346.66a177.14,177.14,0,0,1-6.29,19.79c-.54,1.46-1,2.75-1.45,3.8-.71,1.84-1.17,3-1.17,3l-20-8.69s.16-.82.46-2.2c.23-1,.53-2.41.92-4,2.29-9.31,7.2-26,13.44-27.53C145.05,328.51,152.54,334.93,149.79,346.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,303.14l6.16,4.18,8.37,5.7a26.58,26.58,0,0,0-.19,3.18c0,4.25,1.45,8,7.78,8.84,0,0,7.81,4.16-3,6.08a14.31,14.31,0,0,1-.2,3.55,13.62,13.62,0,0,0-3.84-3c-11.94.94-14-4.43-14-4.43C155.6,322.18,152.61,309.85,150.37,303.14Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9,313a26.58,26.58,0,0,0-.19,3.18c-3-.3-7.11-3-7.8-5.93a12.94,12.94,0,0,1-.38-2.95Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.79,277.41c4.82,1.64,8.64,14.4,3,17.76S157.66,274.29,166.79,277.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07,293.5c2.86,8.92,4.08,14.27,9.86,17.91a12.17,12.17,0,0,0,18.76-10.61c-.11-8.55-4.76-21.7-14.59-23.35A12.31,12.31,0,0,0,147.07,293.5Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.62,281.51l-1.36-7.91a10.61,10.61,0,0,1-6.36,1.49c-9.64-1.22-16.2,5.58-11.27,10.39-4.23,2.39-1.14,8.22,2.24,11.78,4.7,4.95,9.36,7,12.14,4.27,2.58-1.62,2-11.06.76-14.44C148.86,282,154.62,281.51,154.62,281.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,303.21a10,10,0,0,0,6.11,2.88c2.92.21,3.31-2.51,1.6-4.94-1.53-2.19-4.9-4.93-7.4-4S143.81,301.15,145.89,303.21Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,293c.19.74.73,1.25,1.22,1.14s.72-.78.54-1.52-.73-1.25-1.22-1.14S161.34,292.29,161.53,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.91,291.2c.19.73.74,1.25,1.22,1.14s.73-.79.54-1.52-.73-1.25-1.22-1.15S169.73,290.46,169.91,291.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.34,292.14a28.54,28.54,0,0,0,5.15,5.53c-1,1.5-3.38,1.43-3.38,1.43Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.26,290.9a.41.41,0,0,1-.22,0,.46.46,0,0,1-.24-.59,4.33,4.33,0,0,1,3.11-2.57.44.44,0,0,1,.5.38.43.43,0,0,1-.37.5,3.43,3.43,0,0,0-2.42,2.05A.43.43,0,0,1,158.26,290.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,287.55a.44.44,0,0,1-.39-.16,3.74,3.74,0,0,0-3-1.42.46.46,0,0,1-.49-.41.45.45,0,0,1,.41-.48h0a4.6,4.6,0,0,1,3.73,1.74.45.45,0,0,1-.06.63A.37.37,0,0,1,172.79,287.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.23,381.25l9.51.13-6.46-9.95s-8.43,1.4-7.35,5.69Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.78 374.9 170.06 366.94 163.28 371.43 169.74 381.38 175.78 374.9",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44,276.16s6-13.05,18.46-11a9.58,9.58,0,0,0-3.29,1.57s10.7-1.41,14.39,6l-2.11-1.11s3,6.13,0,10.39l-.7-2s-4.15,5.65-10.78,4.4l2.21-1.26s-11.31.16-14.25-2.59A26.73,26.73,0,0,1,146.44,276.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87,343.54a1.45,1.45,0,0,0-1.2.63l-4.84-1.2a1.45,1.45,0,1,0-1.44,1.61,1.43,1.43,0,0,0,1.2-.64l4.84,1.2a1.27,1.27,0,0,0,.06.28l-2.7,2.1a1.48,1.48,0,0,0-.77-.23,1.45,1.45,0,1,0,1.45,1.45,1.55,1.55,0,0,0-.07-.43l2.7-2.1a1.45,1.45,0,1,0,.77-2.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,301.55s-3-.7-11.49-.7c1,2.55,2.85,4.63,7.19,4.59A3.94,3.94,0,0,0,171.08,301.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,303.43a7.89,7.89,0,0,1,4.73,1.24,4.63,4.63,0,0,1-2.71.76,7.81,7.81,0,0,1-4.72-1.23A4.54,4.54,0,0,1,164.76,303.43Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,301.47a1.76,1.76,0,0,1-1.33,1.27,45.42,45.42,0,0,1-7.5-.64,2.38,2.38,0,0,1-1.91-1.25A70.83,70.83,0,0,1,170.7,301.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.14,414.8H110.9a7.63,7.63,0,0,1-7.63-7.62v-3.87a2.1,2.1,0,0,1,2.11-2.1H340.21a2.1,2.1,0,0,1,2.1,2.1h0a2.11,2.11,0,0,1-1.81,2.09l-68.07,9.38A1.42,1.42,0,0,1,272.14,414.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,403.31a2.11,2.11,0,0,1-1.21,1.9,2.07,2.07,0,0,1-.61.19l-68.07,9.38a1.37,1.37,0,0,1-.29,0H110.9a7.62,7.62,0,0,1-7.62-7.62v-3.87a2.1,2.1,0,0,1,2.1-2.1H340.21A2.11,2.11,0,0,1,342.32,403.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,414.8H110.9a7.63,7.63,0,0,1-7.63-7.62v-3.87a2.1,2.1,0,0,1,2.11-2.1H217.13a2.11,2.11,0,0,1,2.11,2.1h0a2.12,2.12,0,0,1-1.82,2.09l-68.07,9.38A1.37,1.37,0,0,1,149.06,414.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.08,
    y: 406.22,
    width: 5.17,
    height: 3.57,
    rx: 0.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.7,
    y: 406.22,
    width: 3.55,
    height: 3.57,
    rx: 0.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.12,
    y: 406.22,
    width: 5.17,
    height: 2.57,
    rx: 0.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.73,
    y: 406.22,
    width: 3.55,
    height: 2.57,
    rx: 0.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.17,
    y: 406.22,
    width: 5.17,
    height: 2.57,
    rx: 0.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.79,
    y: 406.22,
    width: 3.55,
    height: 2.57,
    rx: 0.5,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32,403.31a2.11,2.11,0,0,1-1.21,1.9H218a2.1,2.1,0,0,0-.89-4H340.21A2.11,2.11,0,0,1,342.32,403.31Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.61,
    y: 170.22,
    width: 64.94,
    height: 43.82,
    rx: 8.04,
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,209s1.09,7.57,13.87,17c0,0-6-8.58-6-17Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.61,
    y: 170.22,
    width: 64.94,
    height: 43.82,
    rx: 8.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,209s1.09,7.57,13.87,17c0,0-6-8.58-6-17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,176.4l-1.67,1.4,2.38,3.45,1.9-1.06a11.1,11.1,0,0,0,3.51,2.29l-.19,2.16,4.13.77.59-2.09a11.16,11.16,0,0,0,4.1-.88l1.4,1.67,3.45-2.38-1.06-1.9a11.15,11.15,0,0,0,2.29-3.52l2.16.19.77-4.12-2.09-.59a11.16,11.16,0,0,0-.88-4.11l1.67-1.39-2.38-3.46-1.9,1.06a11.15,11.15,0,0,0-3.52-2.29l.19-2.16-4.12-.76-.59,2.09a11.16,11.16,0,0,0-4.11.88L286.15,160l-3.46,2.38,1.06,1.9a11.1,11.1,0,0,0-2.29,3.51l-2.16-.19-.76,4.13,2.09.59A11.16,11.16,0,0,0,281.51,176.4Zm4.81-5.39a5.68,5.68,0,1,1,4.55,6.62A5.68,5.68,0,0,1,286.32,171Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.08,190.78l3,.54.43-1.5a8,8,0,0,0,2.95-.63l1,1.2,2.48-1.71-.76-1.36a8.14,8.14,0,0,0,1.65-2.53l1.55.14.55-3-1.5-.42a8.16,8.16,0,0,0-.63-2.95l1.19-1-1.7-2.49-1.37.76a8.17,8.17,0,0,0-2.53-1.64l.14-1.55-3-.55-.43,1.5a8.16,8.16,0,0,0-3,.63l-1-1.2-2.48,1.71.76,1.37a7.89,7.89,0,0,0-1.64,2.52l-1.56-.13-.55,3,1.5.43a8.11,8.11,0,0,0,.64,2.94l-1.2,1,1.71,2.48,1.36-.76a8,8,0,0,0,2.53,1.64Zm-.81-9.8a4.08,4.08,0,1,1,3.27,4.75A4.08,4.08,0,0,1,311.27,181Z",
    style: {
      fill: "#31859B",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.29,197.51a9.64,9.64,0,0,0,.76,3.51l-1.43,1.2,2,2.95,1.63-.9a9.52,9.52,0,0,0,3,1.95l-.17,1.85,3.53.65.51-1.78a9.68,9.68,0,0,0,3.51-.75l1.19,1.42,3-2-.91-1.63a9.5,9.5,0,0,0,2-3l1.85.16.65-3.53-1.78-.51a9.73,9.73,0,0,0-.76-3.51l1.43-1.19-2-3-1.63.91a9.72,9.72,0,0,0-3-2l.17-1.85-3.53-.65-.51,1.79a9.47,9.47,0,0,0-3.51.75L294,187l-3,2,.91,1.62a9.38,9.38,0,0,0-2,3l-1.85-.16-.65,3.53Zm4.87-1.1a4.86,4.86,0,1,1,3.9,5.66A4.85,4.85,0,0,1,294.16,196.41Z",
    style: {
      fill: "#31859B",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.94,261.42l-1.77-.92,10.83-21h32.29a11.45,11.45,0,0,0,11.45-11.45V145.19a11.46,11.46,0,0,0-11.45-11.45H111.6a11.46,11.46,0,0,0-11.45,11.45v82.89a11.45,11.45,0,0,0,11.45,11.45h71.57v2H111.6a13.46,13.46,0,0,1-13.45-13.45V145.19a13.46,13.46,0,0,1,13.45-13.45H227.29a13.46,13.46,0,0,1,13.45,13.45v82.89a13.46,13.46,0,0,1-13.45,13.45H196.22Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.82,244.19a3.66,3.66,0,1,1,3.66-3.66A3.66,3.66,0,0,1,185.82,244.19Zm0-5.31a1.66,1.66,0,1,0,1.66,1.65A1.65,1.65,0,0,0,185.82,238.88Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.68,267.27a3.66,3.66,0,1,1,3.66-3.65A3.66,3.66,0,0,1,183.68,267.27Zm0-5.31a1.66,1.66,0,1,0,1.66,1.66A1.65,1.65,0,0,0,183.68,262Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.59,
    y: 143.74,
    width: 117.71,
    height: 84.63,
    rx: 4.76,
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.3,148.51v75.1a4.76,4.76,0,0,1-4.76,4.76H115.36a4.76,4.76,0,0,1-4.76-4.76v-75.1a4.76,4.76,0,0,1,4.76-4.77H223.54A4.76,4.76,0,0,1,228.3,148.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2,172.34v-.5H199.1V144.3h-.5v27.54H169.75V144.3h-.5v27.54H140.4V144.3h-.5v27.54H110.69v.5H139.9v27.71H110.69v.5H139.9v27.26h.5V200.55h28.85v27.26h.5V200.55H198.6v27.26h.5V200.55h29.1v-.5H199.1V172.34Zm-87.8,27.71V172.34h28.85v27.71Zm58.2,0H169.75V172.34H198.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.3,158.68v64.93a4.76,4.76,0,0,1-4.76,4.76H115.37c.23-.59,8-19.32,24.59-19.32,16.88,0,19.42-22.84,29.49-22.84s11,13.85,20.09,13.85S209.1,153.7,228.3,158.68Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,156.4c-.51-.23-1-.42-1.57-.61a14.48,14.48,0,0,0-1.63-.42c-.28-.07-.56-.12-.83-.16h-.06A13.46,13.46,0,0,0,137,155l-.9,0a15.7,15.7,0,0,0-4.06.52c-.27.06-.52.14-.79.22l-.76.25-.76.31a15.53,15.53,0,0,0-2.71,1.48,7.49,7.49,0,0,0-.65.45l-.61.49c-.4.33-.78.67-1.15,1l-.11.12a.43.43,0,0,0-.09.1,3.8,3.8,0,0,0-.34.35c-.17.19-.35.39-.51.59s-.29.35-.43.54-.35.46-.51.71l-.41.63c-.14.23-.27.47-.39.71s-.21.37-.31.57-.26.55-.38.85-.2.49-.29.74a2.27,2.27,0,0,0-.16.46c0,.15-.11.29-.15.45a17.79,17.79,0,0,0-.51,2.3c0,.25-.07.52-.1.78,0,.08,0,.18,0,.26,0,.43,0,.88,0,1.33a16.23,16.23,0,0,0,16.25,16.24,16.19,16.19,0,0,0,9.67-3.21h0l.74-.58c.26-.22.49-.41.72-.64s.45-.44.66-.66.44-.46.64-.7a15.39,15.39,0,0,0,1.76-2.62.83.83,0,0,1,.08-.12,2.22,2.22,0,0,0,.23-.43c.15-.27.28-.56.41-.86a15.41,15.41,0,0,0,.6-1.6c0-.18.1-.35.14-.54s.07-.22.1-.34a2.33,2.33,0,0,0,.08-.36.25.25,0,0,0,0-.12c0-.07,0-.15.06-.21s.06-.29.08-.44a6.29,6.29,0,0,0,.11-.74c0-.11,0-.2,0-.29a.27.27,0,0,1,0-.13c0-.56.08-1.1.08-1.66A16.22,16.22,0,0,0,142.67,156.4Zm-6.56,25.11a10.25,10.25,0,0,1-10.25-10.25,10.15,10.15,0,0,1,2.88-7.12l0,0a10.24,10.24,0,1,1,7.32,17.42Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.77,184.27a15.85,15.85,0,0,1-4.85,2.5,16,16,0,0,1-4.81.73,16.23,16.23,0,0,1-15.52-11.43,16,16,0,0,1-.73-4.81c0-.45,0-.9,0-1.33a2.3,2.3,0,0,0,0-.26c0-.26,0-.53.09-.78a16.29,16.29,0,0,1,.52-2.3c0-.16.09-.3.14-.45a3.11,3.11,0,0,1,.16-.46c.1-.25.19-.51.29-.74a8.19,8.19,0,0,1,.39-.85c.09-.2.2-.38.3-.57a7.14,7.14,0,0,1,.4-.71c.13-.22.28-.43.41-.63s.33-.49.5-.71l.44-.54c.16-.2.33-.4.5-.59s.21-.25.33-.37l.1-.09h0l4.27,4.2s0,0,0,0a10.14,10.14,0,0,0-2.87,7.12,10.23,10.23,0,0,0,16.34,8.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,156.4l-2.42,5.49a10.27,10.27,0,0,0-11.46,2.2l0,0L124.42,160v0l.09-.09.12-.11c.37-.37.75-.71,1.15-1l.61-.49a7.49,7.49,0,0,1,.65-.45,15.53,15.53,0,0,1,2.71-1.48l.76-.31.76-.25c.27-.08.52-.16.79-.22a15.7,15.7,0,0,1,4.06-.52l.9,0a13.46,13.46,0,0,1,1.57.16h.06c.27,0,.55.09.83.16a14.48,14.48,0,0,1,1.63.42C141.63,156,142.16,156.17,142.67,156.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.35,171.26c0,.56,0,1.1-.08,1.66a.27.27,0,0,0,0,.13c0,.09,0,.18,0,.29a6.29,6.29,0,0,1-.11.74c0,.15-.06.29-.08.44a1.29,1.29,0,0,1-.06.21.25.25,0,0,1,0,.12,2.33,2.33,0,0,1-.08.36c0,.12-.06.22-.1.34s-.09.36-.14.54a15.41,15.41,0,0,1-.6,1.6c-.13.3-.26.59-.41.86a2.22,2.22,0,0,1-.23.43,16.4,16.4,0,0,1-1.84,2.74c-.2.24-.41.47-.64.7l-.66.66c-.23.23-.46.42-.72.64l-.74.58v0l-3.56-4.79a10.24,10.24,0,0,0,4.14-8.22Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.84,
    y: 160.06,
    width: 12.27,
    height: 1,
    transform: "translate(-64.97 119.59) rotate(-35.74)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.25,
    y: 152.78,
    width: 18.59,
    height: 9.23,
    rx: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,164.14a1,1,0,1,1-1-1A1,1,0,0,1,149,164.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.3,196.38v27.23a4.76,4.76,0,0,1-4.76,4.76H115.37c.41-.43,7-10.83,17.44-10.83,8.26,0,8.79,5.92,18.68,6.22s19.9-19.57,33.59-19.57S201,211,210.76,211.4,228.3,196.38,228.3,196.38Z",
    style: {
      opacity: 0.5
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetu);
export default __webpack_public_path__ + "static/media/setu.6b60727c82a2921eaeb745857a5fa905.svg";
export { ForwardRef as ReactComponent };